module.exports = __webpack_public_path__ + "img/32.88ca460f.jpg";